
import Uganda from "../Media/UgandaProjectPic.JPG";
import Ethiopia from "../Media/EthiopiaProjectPic.JPG";
import ResearchProject from "../Media/ResearchProjectPicTemp.png";
import Ecuador from "../Media/EcuadorProjectPic.png";
import MidCity from "../Media/MidCity.png";

export const EWBList = [
  
  {
    id: "uganda",
    name: "Uganda",
    image: Uganda,
    meetingTimes: "Wednesdays 6-7pm",
    description:
      "Provide clean water to the Bukonko village in Uganda through a new water system.",
  },
  {
    id: "ethiopia",
    name: "Ethiopia",
    image: Ethiopia,
    meetingTimes: "Mondays 6-7pm",
    description:
      "Increase water access through the construction of latrines, a water tank and a digital library",
  },

  {
    id: "research-project",
    name: "Research Project",
    image: ResearchProject,
    meetingTimes: "Mondays 6-7pm",
    description: "Fire Sensing IoT Technology Development for Active Disaster Monitoring."
  },
  {
    id: "ecuador",
    name: "Ecuador",
    image: Ecuador,
    meetingTimes: "Thursdays 6-7pm",
    description: "Improving access to safe, high-quality water in San Pedro de Cachihuayco, Ecuador"
  },
  {
    id: "MidCityGarden",
    name: "Mid City Garden",
    image: MidCity,
    meetingTimes: "Thursdays 5-6pm",
    description: "A climate resilience initiative creating safe, culturally rooted urban landscapes."
  }
];
